import { t } from '../../utils/i18n';

export const getPatients = () => [{
    id: 1,
    name: t('new_patient'),
    value: "new_patient"
}, {
    id: 2,
    name: t('returning_patient'),
    value: "returning_patient"
}];


export function loadPatients() {
    let list = document.querySelector('.patients__container .patients__list');
    let partientList = ``;
    for (const i of getPatients()) {
        partientList = partientList.concat(`
        <button class="patient" data-patient-id="${i.id}">
            <span class="patient__name">${i.name}</span>
            <span class="patient__checkbox" data-patient-id="${i.id}">
                <i class="patient__icon-check ri-check-line"></i>
            </span>
        </button>
        `);
    }
    list.innerHTML = partientList;
}
